import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      {/* Hero Section */}
      <section className="py-16 bg-[#0F172A]">
        <div className="container-custom">
          <h1 className="heading-h1 text-white">TERMS & CONDITIONS</h1>
          <p className="text-slate-400 mt-4">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-light">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto policy-content">
            <p className="text-body mb-8">
              Welcome to Cart Genix. By accessing our website and using our services, you agree 
              to be bound by these Terms and Conditions. Please read them carefully.
            </p>

            <h2>Acceptance of Terms</h2>
            <p>
              By accessing or using our website and services, you acknowledge that you have read, 
              understood, and agree to be bound by these Terms and Conditions. If you do not agree, 
              please do not use our services.
            </p>

            <h2>Services</h2>
            <p>
              Cart Genix provides professional roofing services including but not limited to:
            </p>
            <ul>
              <li>Roof inspection and assessment</li>
              <li>Roof leak repair</li>
              <li>Emergency roof repair</li>
              <li>Storm damage repair</li>
              <li>Complete roof replacement</li>
              <li>Shingle repair and replacement</li>
              <li>Commercial roofing services</li>
            </ul>

            <h2>Estimates and Pricing</h2>
            <p>
              All estimates provided are based on our initial assessment and are subject to change 
              if additional work is discovered during the project. We will notify you of any changes 
              before proceeding with additional work.
            </p>
            <ul>
              <li>Estimates are valid for 30 days from the date issued</li>
              <li>Final pricing may vary based on material costs and project scope</li>
              <li>Payment terms will be outlined in your service agreement</li>
            </ul>

            <h2>Warranties</h2>
            <p>
              Cart Genix provides warranties on both workmanship and materials:
            </p>
            <ul>
              <li><strong>Workmanship Warranty:</strong> We warranty our work for a minimum of 5 years</li>
              <li><strong>Material Warranty:</strong> Manufacturer warranties apply to all materials used</li>
              <li>Warranty claims must be submitted in writing</li>
              <li>Warranties do not cover damage from natural disasters or neglect</li>
            </ul>

            <h2>Scheduling and Access</h2>
            <p>
              By scheduling services, you agree to:
            </p>
            <ul>
              <li>Provide safe access to your property</li>
              <li>Ensure the work area is clear of obstructions</li>
              <li>Be present or provide authorization for work to be performed</li>
              <li>Notify us of any property-specific hazards or restrictions</li>
            </ul>

            <h2>Cancellation Policy</h2>
            <p>
              If you need to cancel or reschedule, please provide at least 24 hours notice. 
              Cancellations with less than 24 hours notice may be subject to a cancellation fee.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              Cart Genix shall not be liable for any indirect, incidental, special, or consequential 
              damages arising from the use of our services. Our total liability shall not exceed 
              the amount paid for services.
            </p>

            <h2>Insurance</h2>
            <p>
              Cart Genix maintains comprehensive general liability insurance and workers' compensation 
              insurance. Certificates of insurance are available upon request.
            </p>

            <h2>Intellectual Property</h2>
            <p>
              All content on this website, including text, images, logos, and designs, is the property 
              of Cart Genix and protected by copyright laws. You may not reproduce, distribute, or 
              use any content without our written permission.
            </p>

            <h2>Governing Law</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the 
              laws of the State of California, without regard to conflicts of law principles.
            </p>

            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Changes will 
              be effective immediately upon posting to this website.
            </p>

            <h2>Contact Information</h2>
            <p>For questions about these Terms and Conditions, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> support@cartgenix.store</li>
              <li><strong>Phone:</strong> +1-888-445-1244</li>
              <li><strong>Address:</strong> 998 Sunset Boulevard, Los Angeles, CA 80021</li>
            </ul>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <Link to="/" className="text-[#F97316] font-semibold hover:underline">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
